<template>
    <div class="dialog-container flex flex-direction padding-tb-xs" :style="`display: ${dialogVisible ? 'flex' : 'none'}`">
        <div class="content-container progress-viewer-header flex flex-direction" v-if="files.length">
            <div class="flex align-center justify-between padding-lr-xs">
                <div class="flex align-center text-sm text-black text-bold" v-if="files.some(s=> s.status === 1)">
                    <i class="el-icon-loading text-blue text-df margin-right-xs"></i>上传中
                </div>
                <div class="flex align-center text-sm text-black text-bold" v-else-if="files.every(s=> s.status === 0)">
                    <i class="el-icon-time text-blue text-df margin-right-xs"></i>等待上传
                </div>
                <div class="flex align-center text-sm text-black text-bold" v-else>
                    <i class="el-icon-success text-green text-df margin-right-xs"></i>全部上传完成
                </div>
                <i class="el-icon-close text-df text-black cursor" @click="cancel"></i>
            </div>
            <div class="info bg-gray flex align-center justify-between margin-tb-xs" v-if="files.some(s=> s.status === 1)">
                <div class="time">速度：{{ speed | formatSeep }}M/s</div>
                <div class="time">预计：{{ time | picTime }}</div>
            </div>
<!--            <div class="info bg-gray flex align-center justify-end margin-tb-xs cursor" v-else-if="files.every(s=> s.status === 0)" @click="startUpFile(-1)">-->
<!--                开始上传-->
<!--            </div>-->
            <div class="info bg-gray flex align-center justify-between margin-tb-xs" v-else>
                <div class="time">成功上传{{files.filter(s=> {return s.status === 2}).length}}个文件，失败{{files.filter(s=> {return s.status === -1}).length}}个文件</div>
            </div>
            <div class="list padding-lr-xs">
                <div class="flex flex-direction " v-for="(item,index) in files" :key="index">
                    <div class="flex align-center justify-between padding-tb-xs">
                      <div class="flex align-center">
                          <div class="file__type"><div class="name">{{item.name | fileType}}</div></div>
                          <div class="flex flex-direction justify-between margin-lr-xs">
                              <div class="title text-bold">{{ item.name }}</div>
                              <div class="time margin-top-xs" v-if="item.progress && item.progress.total">
                                 {{ item.progress.total.loaded | formatSize }}/{{ item.progress.total.size | formatSize }}
                              </div>
                          </div>
                      </div>
                        <el-progress class="text-sm" style="width: 30px" color="#0a2240" type="circle"
                                     :width="30" :stroke-width="2" :percentage="Math.floor(item.status ? item.progress.total.percent : 0)" v-if="item.status === 1"></el-progress>
                        <div class="text-xs" :class="item.status | status" v-else></div>
                    </div>
                    <el-divider></el-divider>
                </div>
            </div>

        </div>
        <div class="text-xs text-red padding-xs" style="line-height: 1.5">温馨提示：大文件上传较慢，请勿刷新或关闭页面及窗口，请您耐心等待。</div>
    </div>
</template>

<script>
import {fileTypeName} from "@/utils/utils";

export default {
    name: "UploadFileLoading",
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        auto: { // 是否自动上传
            type: Boolean,
            default: false
        },
        files: { //本次上传的总量控制信息，单位为字节，注意这里的 total 跟文件大小并不一致。
            type: [String, Array],
            default: ''
        },
    },
    data() {
        return {
            startTimeRef: {
                current: ''
            },
            speed: 0,
            time: 0
        }
    },
    created() {

    },
    methods: {
        // 获取上传速度
        getSpeed() {
            if (!this.files.length) {
                this.speed = 0
                this.time = 0
                return
            }
            if (!this.startTimeRef.current) this.startTimeRef.current = Date.now()

            const duration = (Date.now() - (this.startTimeRef.current || 0)) / 1000 // 间隔秒数
            const size = this.files.reduce((pre, next) => {
                if (Array.isArray(next.progress.chunks)) {
                    return pre + next.progress.chunks.reduce(((acc, cur) => (
                        !cur.fromCache ? cur.loaded + acc : acc
                    )), 0)
                } else {
                    return next.progress && next.progress.total && next.progress.total.loaded ? pre + next.progress.total.loaded : 0
                }
            }, 0)

            this.speed = size > 0 ? size / duration : 0

            const surplus_size = this.files.reduce((pre, next) => {
                return pre + (next.progress && next.progress.total && next.progress.total.loaded ? next.progress.total.size - next.progress.total.loaded : 0)
            }, 0)
            this.time = surplus_size ? surplus_size / this.speed : 0
        },
        startUpFile(data){
            this.$emit('startUpFile', {index:data})
        },
        stopUpFile(data){
            console.log(data)
            this.$emit('stopUpFile', {index:data})
        },
        cancel() {
            this.$emit('watchState', false)
        }
    },
    watch: {

        files: {
            handler(newValue) {
                this.files = newValue
                this.getSpeed()
            },
            deep: true
        },
        dialogVisible: {
            handler(newValue) {
                if (!newValue)this.startTimeRef.current = ''
            }
        }
    },
    filters: {
        fileType(val) {
            return fileTypeName(val)
        },
        formatSize(val) {
            let fileSize = Number(val)
            if (!fileSize) return ''
            let arrUnit = ["B", "K", "M", "G", "T", "P"],
                baseStep = 1024,
                unitCount = arrUnit.length,
                unitIndex = 0;
            while (fileSize >= baseStep && unitIndex < unitCount - 1) {
                unitIndex++;
                fileSize /= baseStep;
            }
            fileSize = fileSize.toFixed(2);
            return Number(fileSize) +  arrUnit[unitIndex];
        },
        formatSeep(val) {
            return val ? (Number(val)/1024/1024).toFixed(2) : 0
        },
        picTime(val) {
            let _val = Math.floor(val)
            if (_val > 0) {
                let hh = parseInt(_val / 3600);
                if (hh < 10) hh = "0" + hh;
                let mm = parseInt((_val - hh * 3600) / 60);
                if (mm < 10) mm = "0" + mm;
                let ss = parseInt((_val - hh * 3600) % 60);
                if (ss < 10) ss = "0" + ss;
                let length = hh + ":" + mm + ":" + ss;
                return length;
            } else {
                return "00:00:00";
            }
        },
        status(val) {
            switch (Number(val)) {
                case -1:
                    return 'el-icon-error text-red'
                case 1:
                    return '上传中'
                case 0:
                    return 'el-icon-time'
                case 2:
                    return 'el-icon-success text-green'
            }
        }
    }
}
</script>

<style scoped lang="scss">
.dialog-container {
    width: 390px;
    background-color: #ffffff;
    border-radius: 8px;
    border: 1px solid var(--grayLine);
    position: fixed;
    z-index: 100;
    bottom: 30px;
    right: 30px;
    box-shadow: 0 6px 18px 1px rgba(10, 34, 64, 0.45);
    .list{
        max-height: 300px;
        overflow: auto;
        margin: 0 5px;
        &::-webkit-scrollbar {
            width: 3px;
            height: 10px;
            /*background-image: var(--gradualRed);*/
        }

        &::-webkit-scrollbar-track {
            border-radius: 10px;
            background-color: #f6f6f6;
        }

        &::-webkit-scrollbar-thumb {
            border-radius: 10px;
            width: 5px;
            height: 10px;
            background: #999999;
        }
        .file__type{
            width: 30px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            color: white;
            background: var(--blue);
            border-top-right-radius: 6px;
            .name{
                font-size: 12px;
                transform: scale(0.8);
            }
        }
    }

    .title{
        font-size: 14px;
        color: #333333;
        line-height: 1;
    }
    .time{
        font-size: 14px;
        color: #333333;
        line-height: 1;
        text-align: start;
    }
    .info {
        padding: 6px 10px;
    }
}
</style>